import { toast } from "react-toastify";
import axios from "axios";
import Cookie from "./Cookie";
import { translate } from "../i18n";
import { AUTH_TOKEN, REFRESH_TOKEN } from "../Constant/constants";
import { REFRESH_TOKEN_URL } from "../Constant/api";

export const authService = async (endpoint, method, data) => {
  try {
    const token = Cookie.getCookie(AUTH_TOKEN);
    const res = await axios.request({
      url: `${process.env.REACT_APP_API_DOMAIN_URL}${endpoint}`,
      headers: {
        authorization: `Bearer ${token}`,
      },
      method,
      data,
      // ...settings,
    });
    return res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      try {
        // Attempt to refresh the token
        await generateNewToken();
        // Retry the original request with the new token
        const newToken = Cookie.getCookie(AUTH_TOKEN);

        const res = await axios.request({
          url: `${process.env.REACT_APP_API_DOMAIN_URL}${endpoint}`,
          headers: {
            authorization: `Bearer ${newToken}`,
          },
          method,
          data,
          // ...settings,
        });
        return res.data;
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }
    if (e?.response?.status === 500) {
      toast.error(translate("common.messages.notification.failed.serverError"));
    }
    if (e.response && e?.response?.status === 403) {
      toast.error(
        translate("common.messages.notification.failed.unauthorized")
      );
    }
    return Promise.reject(e);
  }
};

export const unAuthService = async (endpoint, method, data, settings) => {
  try {
    const res = await axios.request({
      url: `${process.env.REACT_APP_API_DOMAIN_URL}${endpoint}`,
      method,
      data,
      ...settings,
    });
    return res.data;
  } catch (e) {
    if (e?.response?.status === 500) {
      toast.error(translate("common.messages.notification.failed.serverError"));
    }
    if (e?.response?.status === 403) {
      toast.error(
        translate("common.messages.notification.failed.unauthorized")
      );
    }
    return Promise.resolve({ success: false, data: e });
  }
};

export const generateNewToken = async () => {
  try {
    const refreshToken = Cookie.getCookie(REFRESH_TOKEN);
    if (refreshToken) {
      const header = {
        headers: { Authorization: `Bearer ${refreshToken}` },
      };
      const response = await unAuthService(
        REFRESH_TOKEN_URL,
        "POST",
        {},
        header
      );
      if (response.success) {
        const token = response.data;
        Cookie.setCookie(AUTH_TOKEN, token);
      } else {
        Cookie.deleteCookie(AUTH_TOKEN);
        Cookie.deleteCookie(REFRESH_TOKEN);
        window.location.href = "/";
      }
    }
  } catch (e) {
    window.location.href = "/";
    toast.error(
      translate("common.messages.notification.failed.somethingWentWrong")
    );
  }
};

export const newAuthService = async (
  endpoint,
  method,
  data,
  _,
  responseType,
  signal
) => {
  try {
    const token = Cookie.getCookie(AUTH_TOKEN);
    const res = await axios.request({
      url: `${process.env.REACT_APP_API_DOMAIN_URL}${endpoint}`,
      headers: {
        authorization: `Bearer ${token}`,
      },
      responseType: responseType,
      method,
      data,
      signal,
      // ...settings,
    });
    return Promise.resolve({ status: true, data: res.data });
  } catch (e) {
    if (e?.response?.status === 401) {
      try {
        // Attempt to refresh the token
        await generateNewToken();
        // Retry the original request with the new token
        const newToken = Cookie.getCookie(AUTH_TOKEN);

        const res = await axios.request({
          url: `${process.env.REACT_APP_API_DOMAIN_URL}${endpoint}`,
          headers: {
            authorization: `Bearer ${newToken}`,
          },
          method,
          data,
          // ...settings,
        });
        return Promise.resolve({ status: true, data: res.data });
      } catch (refreshError) {
        return Promise.resolve({ status: false, data: refreshError });
      }
    }
    if (e?.response?.status === 500) {
      toast.error(translate("common.messages.notification.failed.serverError"));
    }
    if (e?.response && e?.response?.status === 403) {
      toast.error(
        translate("common.messages.notification.failed.unauthorized")
      );
    }
    return Promise.resolve({ status: false, data: e });
  }
};
